import React, { useState } from 'react';
import { Avatar, Dropdown, MenuProps } from 'antd';
import { UserOutlined, SettingOutlined, LogoutOutlined, CrownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearUser } from '../../store/userSlice';
import AuthModal from '../auth/AuthModal';
import { auth } from '../../services/api';

const UserContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const UserAvatar = styled(Avatar)`
  background-color: #1890ff;
`;

const UserInfoContent = styled.div`
  margin-left: 12px;
  flex: 1;
  min-width: 0;
`;

const UserName = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const UserVersion = styled.div<{ $isPremium: boolean }>`
  font-size: 12px;
  color: ${props => props.$isPremium ? '#f59e0b' : '#64748b'};
`;

interface UserInfoProps {
  user?: {
    email: string;
    isPremium: boolean;
  };
}

const UserInfo: React.FC<UserInfoProps> = ({ user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authModalVisible, setAuthModalVisible] = useState(false);

  const handleLogout = () => {
    auth.logout();
    dispatch(clearUser());
    navigate('/');
  };

  const handleAuthSuccess = () => {
    window.location.reload();
  };

  if (!user) {
    return (
      <>
        <UserContainer onClick={() => setAuthModalVisible(true)} style={{ cursor: 'pointer' }}>
          <UserAvatar icon={<UserOutlined />} />
          <UserInfoContent>
            <UserName>未登录</UserName>
            <UserVersion $isPremium={false}>
              点击登录
            </UserVersion>
          </UserInfoContent>
        </UserContainer>

        <AuthModal
          visible={authModalVisible}
          onClose={() => setAuthModalVisible(false)}
          onSuccess={handleAuthSuccess}
        />
      </>
    );
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'upgrade',
      icon: <CrownOutlined />,
      label: user.isPremium ? '续费会员' : '升级会员',
      onClick: () => navigate('/pricing')
    },
    {
      type: 'divider'
    },
    {
      key: 'profile',
      icon: <SettingOutlined />,
      label: '个人设置',
      onClick: () => navigate('/profile')
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
      <UserContainer>
        <UserAvatar icon={<UserOutlined />} />
        <UserInfoContent>
          <UserName>{user.email}</UserName>
          <UserVersion $isPremium={user.isPremium}>
            {user.isPremium ? '高级版' : '免费版'}
          </UserVersion>
        </UserInfoContent>
      </UserContainer>
    </Dropdown>
  );
};

export default UserInfo; 